import { Nav, NavItem, NavLink } from "reactstrap";
import { Href } from "../../../Utils/Constants";

type propsType = {
    basicTab: string;
    setBasicTab: (data: string) => void;
}

export default function FTPNav({ basicTab, setBasicTab }: propsType) {

    return (
        <Nav tabs className='border-tab nav-info mb-0'>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '1' ? 'active' : ''}`} onClick={() => setBasicTab('1')}><i className="icofont icofont-ui-home" />{'Import'}</NavLink>
            </NavItem>
           <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '2' ? 'active' : ''}`} onClick={() => setBasicTab('2')}><i className="icofont icofont-ui-message" />{'Export'}</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '3' ? 'active' : ''}`} onClick={() => setBasicTab('3')}><i className="icofont icofont-man-in-glasses" />{'Import Logs'}</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href={Href} className={`nav-border txt-info tab-info ${basicTab === '4' ? 'active' : ''}`} onClick={() => setBasicTab('4')}><i className="icofont icofont-man-in-glasses" />{'Export Logs'}</NavLink>
            </NavItem>
        </Nav>
    )
}
